import axios from "axios";

export function getRestaurantData(idOrPrefix) {
  const RESTAURANT_DETAILS = `/api/v1/customer/restaurants/${idOrPrefix}`;
  return axios.get(RESTAURANT_DETAILS, {
    validateStatus(status) {
      return true;
    },
  });
}

export const getRestaurantPageData = (restaurantPrefix) => {
  return axios.get(`/api/v1/user/restaurant-page/${restaurantPrefix}`, {
    validateStatus(status) {
      return true;
    },
  });
};

export function getBrandLandingData(brandId) {
  return axios.get(`/api/v1/brand/${brandId}`, {
    validateStatus() {
      return true;
    },
  });
}

export const getImage = (key) => {
  return axios
    .get(`/api/v1/user/get-image/${key}`, {
      validateStatus() {
        return true;
      },
    })
    .catch(() => ({ data: { success: false } }));
};

export const getSingleCampaignAPI = (code, { scope, scopeEntityId } = {}) => {
  const params = new URLSearchParams();
  if (scope) params.append("scope", scope);
  if (scopeEntityId) params.append("scopeEntityId", scopeEntityId);
  const queryString = params.toString();
  return axios.get(`/api/v1/campaign/${code}${queryString ? `?${queryString}` : ""}`, {
    validateStatus(status) {
      return true;
    },
  });
};
